import React from 'react';

export default {
  svg: (
    <g>
      <path d="M246.69,126.83l-21-17.42A7.5,7.5,0,0,0,216.12,121l15.08,12.51-24.27,15.61V81.92H192.7l.42-.48L150,43.52,106.88,81.44l.42.48H93.07v67.15L68.85,133.49,84.15,121a7.5,7.5,0,1,0-9.5-11.61l-21.3,17.42a7.49,7.49,0,0,0-2.6,7.29,7.52,7.52,0,0,0-.15,1.42V247.91a7.5,7.5,0,0,0,7.5,7.5H241.9a7.5,7.5,0,0,0,7.5-7.5V135.5a7.33,7.33,0,0,0-.15-1.41A7.49,7.49,0,0,0,246.69,126.83ZM150,63.5,171,81.92h-41.9ZM108.07,96.92h83.86v61.8l-41.93,27-41.93-27ZM234.4,240.41H65.6V149.24l80.34,51.67a7.51,7.51,0,0,0,8.12,0l80.34-51.67Zm-60.93-112H126.53v-15h46.94Zm0,27.34H126.53v-15h46.94Z" />
    </g>
  ),
  viewBox: '0 0 300 300'
};
